<template>
  <div class="animated fadeIn">
    <b-card v-show="showList">
      <div slot="header">Accrued Template - Reguler Cost 
        <div class="card-header-actions">
          <b-button variant="btn btn-primary mr-1" @click="add">Add</b-button>
          <button class="btn btn-primary mr-1" @click="showFilter=!showFilter">
            <i class="fa fa-filter"></i>Filter
          </button>
          <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-row v-show="showFilter">
        <b-col lg="6">
            <b-input-group >
                <b-input-group-prepend><label>Description</label></b-input-group-prepend>
                <b-form-input v-model="tblData.keterangan" ></b-form-input>
            </b-input-group>
            <b-input-group >
                <b-input-group-prepend><label>Dimension Name</label></b-input-group-prepend>
                <b-form-select v-model="tblData.DimCol" :plain="true" :options="dimension"></b-form-select>
                <b-input-group-prepend><span class="input-group-text">value</span></b-input-group-prepend>
                <b-form-input v-model="tblData.DimVal" placeholder="Dimension Value"></b-form-input>
              </b-input-group>
        </b-col>
        <b-col lg="6">
            <b-input-group >
                <b-input-group-prepend><label>Debit Account</label></b-input-group-prepend>
                <b-form-input v-model="tblData.kodeacc" placeholder="Account Code"></b-form-input>
                <b-form-input v-model="tblData.namaacc" placeholder="Account Name" class="ml-1"></b-form-input>                
            </b-input-group>
          <b-input-group >
            <b-input-group-prepend><label>Vendor/Supplier</label></b-input-group-prepend>
            <b-form-input v-model="tblData.vendor" placeholder="Vendor/Supplier"></b-form-input>
              <b-input-group-append> <b-button class="btn btn-success ml-3 mr-1" @click="refresh()" > <i class="fa fa-refresh"></i> Apply Filter</b-button></b-input-group-append>
              <b-input-group-append> <b-button class="btn btn-secondary" @click="clearFilter()" > <i class="fa fa-eraser"></i>Clear Filter</b-button></b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
      <b-table
        class="mb-0"
        ref="table"
        outlined  responsive hover small
        style="font-size:smaller;" 
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit"
        @row-clicked="rowClicked"
      >
       <template v-slot:cell(index)="data">
          {{data.index + 1}}
        </template>      
        <template v-slot:cell(nilai)="data">
          {{data.item.nilai|numFormat}}
        </template>
        <template v-slot:cell(Dim1)="data">
          <span v-if="(data.item.Dim1)">{{data.item.Dim1}} | {{data.item.Dim1Txt}}</span>
        </template>
        <template v-slot:cell(Dim2)="data">
          <span v-if="(data.item.Dim2)">{{data.item.Dim2}} | {{data.item.Dim2Txt}}</span>
        </template>
        <template v-slot:cell(Dim3)="data">
          <span v-if="(data.item.Dim3)">{{data.item.Dim3}} | {{data.item.Dim3Txt}}</span>
        </template>
        <template v-slot:cell(Dim4)="data">
          <span v-if="(data.item.Dim4)">{{data.item.Dim4}} | {{data.item.Dim4Txt}}</span>
        </template>
        <template v-slot:cell(Dim5)="data">
          <span v-if="(data.item.Dim5)">{{data.item.Dim5}} | {{data.item.Dim5Txt}}</span>
        </template>
        <template v-slot:cell(Dim6)="data">
          <span v-if="(data.item.Dim6)">{{data.item.Dim6}} | {{data.item.Dim6Txt}}</span>
        </template>

        <template v-slot:cell(action)="data">
          <div class="text-center">
          <a href="javascript:void(0)" @click.stop="edit(data.item)">
            <i class="fa fa-pencil"></i>
          </a>
          |
          <a href="javascript:void(0)" class="text-danger" @click.stop="deleteConfirm(data.item)">
            <i class="fa fa-trash"></i>
          </a>
          </div>
        </template>
      </b-table>
      <b-row class="mt-2">
        <b-col cols="4">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="4" >
            <b-form-group label-cols=3 label="Limit per page" class="mb-0">
            <b-form-select :options="[10, 20, 30, 50, 70, 90, 120]" :plain="true" v-model="tblData.limit"  style="width:80px;"/>
            </b-form-group>
        </b-col>        
        <b-col cols="4">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal>
    </b-card>
    <b-card v-if="showForm">
      <div slot="header">Accrued Template Form 
        <div class="card-header-actions">
          <button class="btn btn-primary mr-1"   @click="save()">
            <i class="fa fa-save"></i> Save
          </button>
          <b-button class="btn btn-primary mr-1" @click="closeFrm()" > <i class="fa fa-close"></i> Close Form</b-button>
        </div>
      </div>
      <b-row >
          <b-col class="pr-4" cols="6">
                <b-input-group >
                    <b-input-group-prepend><label>Description</label></b-input-group-prepend>
                    <b-form-input v-model="frmdata.keterangan" :state="!$v.frmdata.keterangan.$error"></b-form-input>
                </b-input-group>
                <b-row>
                  <b-col cols="6" >
                    <b-input-group >
                        <b-input-group-prepend><label>Accrued Amt./Month</label></b-input-group-prepend>
                        <my-number class="margin-left:-15px; form-control text-right" separator="," v-model="frmdata.nilai" :precision="2" :state="!$v.frmdata.nilai.$error"></my-number>
                    </b-input-group>
                  </b-col>
                </b-row>
                  <b-input-group >
                      <b-input-group-prepend><label>Supplier/Vendor</label></b-input-group-prepend>
                      <b-form-input readonly v-model="frmdata.vendorinfo" :state="!$v.frmdata.vendor.$error"></b-form-input>
                      <b-input-group-append>
                      <b-btn text="Button" @click="lkuVendorShow=true" >
                          <i class="fa fa-search"></i>
                      </b-btn>
                      </b-input-group-append>
                  </b-input-group>
                  <b-input-group >
                      <b-input-group-prepend><label>Debit Account</label></b-input-group-prepend>
                      <b-form-input readonly v-model="frmdata.dbAccount" :state="!$v.frmdata.db_kodeacc.$error"></b-form-input>
                      <b-input-group-append>
                      <b-btn text="Button" @click="showLkuCoa('debit')" >
                          <i class="fa fa-search"></i>
                      </b-btn>
                      </b-input-group-append>
                  </b-input-group>
                  <b-input-group >
                      <b-input-group-prepend><label>Credit Account</label></b-input-group-prepend>
                      <b-form-input readonly v-model="frmdata.krAccount" :state="!$v.frmdata.kr_kodeacc.$error"></b-form-input>
                      <b-input-group-append>
                      <b-btn text="Button" @click="showLkuCoa('credit')" >
                          <i class="fa fa-search"></i>
                      </b-btn>
                      </b-input-group-append>
                  </b-input-group>
          </b-col>
          <b-col class="pr-4" cols="6">
              <v-dim :model="frmdata"></v-dim>
          </b-col>
      </b-row>
    </b-card>
        <b-modal v-model="lkuCoaShow" size="lg" :hide-footer="true" title="List of GL Account" :centered="true" :lazy="true">
            <lku-coa @click="onSelectLkuCoa" :tahun="tahun" :key="tahun"></lku-coa>
        </b-modal>        
        <b-modal v-model="lkuVendorShow" size="lg" :hide-footer="true" title="List of Supplier/Vendor" :centered="true" :lazy="true">
            <lku-vendor @click="onSelectLkuVendor" ></lku-vendor>
        </b-modal>        

  </div>
</template>

<style lang="scss">
    .list-of-accrued {
      table {
        td:nth-child(1) {
          width: auto;
        }
        td:nth-child(2) {
          width: 120px;
        }
      }
    }
 
</style>


<script>
import myNumber from "../../components/my-number";
import vDim from "../lookup/dim";
import lkuCoa from "../lookup/lkuCoa";
import lkuVendor from "../lookup/lkuVendor";
import toastr from "mini-toastr";
import accrued from "../../apis/accrued";
import { validationMixin } from "vuelidate";
import { required, minValue, maxLength, numeric } from "vuelidate/lib/validators";

toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    frmdata: {
        keterangan: { required },
        vendor: { required },
        db_kodeacc: { required },
        kr_kodeacc: { required },
        nilai: { required, minValue:minValue(1) },
    },
  }, 
  data() {
    return {
      showDelConfirm: false,
      saveEnabled: true, 
      horizontal: true,
      showList:true,
      showForm:false,
      showFilter:false,
      lkuCoaShow:false,
      lkuCoaCaller:'debit',
      lkuVendorShow:false,
      tahun:(this.$store.state.user.tglaktif || '').substring(0,4),
      frmdata:{db_kodeacc:'',kr_kodeacc:'',vendor:'',nilai:0},
      tblData: {
        items: [],
        page: 1,
        limit: 15,
        total: 0,
        DimCol:'Dim1',
        sortBy: null,
        sortDesc: false,
      },
    };
  },
  components: {myNumber,vDim,lkuCoa,lkuVendor},
  computed: {
    dimension(){
      return this.$store.state.dimension;
    },
    tblFields(){
      const fields=[
          {
            key: "index",
            thStyle: "width:80px",
            label: "Nomor",
          },
          {
            key: "db_kodeacc",
            thStyle: "width:100px",
            label: "DB Account#",
            sortable: true
          },
          {
            key: "db_namaacc",
            label: "DB Account Name",
            thStyle: "width:250px",
            sortable: true
          },
          {
            key: "keterangan",
            label: "Description",
            sortable: true
          },
          {
            key: "vendorinfo",
            label: "Supplier/Vendor",
            thStyle: "width:200px",
            sortable: true
          },
          {
            key: "nilai",
            label: "Value per Month",
            thStyle: "width:150px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "kr_kodeacc",
            thStyle: "width:100px",
            label: "CR Account#",
            sortable: true
          },
          {
            key: "kr_namaacc",
            label: "CR Account Name",
            thStyle: "width:250px",
            sortable: true
          },
        ];
        const dims = this.$store.state.dimension;
        for (let i = 0; i < dims.length; i += 1) {
          fields.push(          {
            key: dims[i].value,
            thStyle: "width:100px",
            label: dims[i].text,
            sortable: true
          },)
        }

        fields.push({
            key: "action",
            label: "Action",
            thStyle: "width:40px",
            thClass: "text-center",
          });
      return fields;
    },
    invalidFormdata() {
      this.$v.frmdata.$touch();
      return this.$v.frmdata.$invalid;
    },

  },
  methods: {
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
    },
    data: async function(ctx) {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";

      const list = await accrued.list(this.tblData);      
      return list;
    },
    refresh(ctx) {
      if (this.$refs.table)  this.$refs.table.refresh();
    },
    clearFilter(ctx) {
        this.tblData.kodeacc= '';
        this.tblData.namaacc=  '';
        this.tblData.keterangan=  '';
        this.tblData.vendor=  '';
        this.tblData.DimVal=  '';
        this.refresh();
    },
    add: function(data) {
        this.frmdata.db_kodeacc='';
        this.frmdata.kr_kodeacc='';
        this.frmdata.vendor='';
        this.frmdata.nilai=0;
      this.frmdata.dbAccount = '';
      this.frmdata.krAccount = '';

      this.showForm=true;
      this.showList=false;
    },
    edit: function(data) {
      this.model=data;
        this.frmdata.db_kodeacc='';
        this.frmdata.kr_kodeacc='';
        this.frmdata.vendor='';
        this.frmdata.nilai=0;

        for (var key in this.model) {
            this.frmdata[key] = this.model[key];
        }
      this.frmdata.dbAccount = data.db_kodeacc.trim() + ' | ' + data.db_namaacc.trim();
      this.frmdata.krAccount = data.kr_kodeacc.trim() + ' | ' + data.kr_namaacc.trim();
        // if (this.frmdata.Dim1) this.frmdata.Dim1Info=`${frmdata.Dim1} | ${frmdata.Dim1Txt}`;
        // if (this.frmdata.Dim2) this.frmdata.Dim2Info=`${frmdata.Dim2} | ${frmdata.Dim2Txt}`;
        // if (this.frmdata.Dim3) this.frmdata.Dim3Info=`${frmdata.Dim3} | ${frmdata.Dim3Txt}`;
        // if (this.frmdata.Dim4) this.frmdata.Dim4Info=`${frmdata.Dim4} | ${frmdata.Dim4Txt}`;
        // if (this.frmdata.Dim5) this.frmdata.Dim5Info=`${frmdata.Dim5} | ${frmdata.Dim5Txt}`;
        // if (this.frmdata.Dim6) this.frmdata.Dim6Info=`${frmdata.Dim6} | ${frmdata.Dim6Txt}`;
        this.dimension.forEach((dim) => {
            if (this.model[dim.value]) {
                this.frmdata[dim.value] = this.model[dim.value];
                this.frmdata[`${dim.value}Txt`] = this.model[`${dim.value}Txt`];
                this.frmdata[`${dim.value}Info`] = this.model[dim.value] + ' | '+ this.model[`${dim.value}Txt`];
            }
        });

      this.showForm=true;
      this.showList=false;

    },
    save: async function () {
        if (!this.saveEnabled) {
            toastr.error('View mode cannot be Saved');
            return;
        }
        this.saveEnabled=false;            

          if (this.invalidFormdata) {
              console.log('validation : ', this.$v.frmdata);
              console.log('frmdata : ',this.frmdata);
              toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
            this.saveEnabled=true;            
        } else {
            try {
              const hasil = await accrued.save(this.frmdata);
              console.log('AccueTempl:', hasil);
              toastr.success(`Saved Successfully`, "Accrued Template - Reguler Cost ",5000);
              this.saveEnabled=true;            
              this.closeFrm();    
              // if (this.frmdata.accrutmpkey){
              //   for (var key in this.frmdata) {
              //       this.model[key] = this.frmdata[key];
              //   }
              // }
              setTimeout(() => {
                  this.refresh();              
              }, 500);       

            } catch (error) {
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }   
                this.saveEnabled=true;            
            }
        }
    },    
    deleteConfirm(item) {
      this.model = item;
      this.showDelConfirm = true;
    },
    deleteData: async function() {
      await accrued.remove(this.model);
      this.refresh();
    },
    rowClicked(record, index) {
      if ((this.model) && (this.model._rowVariant)) {
          delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant= 'info';
      this.$forceUpdate();
    },
    showLkuCoa(callerObj)
    {
      this.lkuCoaShow=true;
      this.lkuCoaCaller=callerObj;
    },
    onSelectLkuCoa(_selected) {
        if (this.lkuCoaCaller==='debit'){
            this.frmdata.dbAccount = _selected.kodeacc.trim() + ' | ' + _selected.namaacc.trim();
            this.frmdata.db_kodeacc = _selected.kodeacc;
            this.frmdata.db_namaacc = _selected.namaacc;
        } else {
            this.frmdata.krAccount = _selected.kodeacc.trim() + ' | ' + _selected.namaacc.trim();
            this.frmdata.kr_kodeacc = _selected.kodeacc;
            this.frmdata.kr_namaacc = _selected.namaacc;
        }
        this.lkuCoaShow=false;
    },
    onSelectLkuVendor(_selected) {
        this.frmdata.vendorinfo = _selected.vendor_code.trim() + ' | ' + _selected.vendor_name.trim();
        this.frmdata.vendor = _selected.vendor_code;
        this.lkuVendorShow=false;
    },
    closeFrm(){
      this.showForm=false;
      this.showList=true;
      this.saveEnabled=true;            
    },    
    close(){
      router.push("home");
    },    
  }
};
</script>
